import { GET_NFT ,GET_NFT_SUCCESS, NFT_API_ERROR} from "./actionTypes";

export const getNFT = (data, history) => {
    return {
      type: GET_NFT,
      payload: { data, history },
    }
  }
  
  export const  getNFTSuccess = (payload) => {
    return {
      type: GET_NFT_SUCCESS,
      payload: payload,
    };
  };



  export const nftApiError = error => {
    return {
      type: NFT_API_ERROR,
      payload: error,
    }
  }